// Ranking weights for the structural-quality score (editable-plan Part 1a, D25). The key
// names follow _scoreFrames in src/AppShell.jsx (minDist 40%, packing 35%, density 25%).
// 1a records the weights a run used (run docs, resultsRun); Part 2c lets the expert
// change them and reuses these keys.
export const BUILTIN_RANKING_WEIGHTS = Object.freeze({ minDist: 0.40, packing: 0.35, density: 0.25 });
export const RANKING_WEIGHT_KEYS = Object.freeze(['minDist', 'packing', 'density']);

/** The weights normalized to sum 1, or null. Valid weights are a plain object with exactly
 * the RANKING_WEIGHT_KEYS, each a finite number from 0 to 1, with a sum above 0. */
export function validRankingWeights(w) {
  if (w === null || typeof w !== 'object' || Array.isArray(w)) return null;
  const keys = Object.keys(w);
  if (keys.length !== RANKING_WEIGHT_KEYS.length || !RANKING_WEIGHT_KEYS.every((k) => keys.includes(k))) return null;
  if (!RANKING_WEIGHT_KEYS.every((k) => typeof w[k] === 'number' && Number.isFinite(w[k]) && w[k] >= 0 && w[k] <= 1)) {
    return null;
  }
  const sum = RANKING_WEIGHT_KEYS.reduce((total, k) => total + w[k], 0);
  if (!(sum > 0)) return null;
  return { minDist: w.minDist / sum, packing: w.packing / sum, density: w.density / sum };
}
